/* eslint-disable array-bracket-spacing */
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { codeThirdParty, commonStatus } from '@constants/masterData';
import useBasicForm from '@hooks/useBasicForm';
import useTranslate from '@hooks/useTranslate';
import { BaseForm, SelectField, TextField } from '@itz/react-cms-element';
import { Card, Col, Row } from 'antd';

const ThirdPartyForm = (props) => {
    const translate = useTranslate();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const restaurantId = queryParams.get('restaurantId');
    const [hidden, setHidden] = useState(false);

    const { formId, actions, dataDetail, onSubmit, setIsChangedFormValues, branchs, isEditing } = props;
    const { form, mixinFuncs, onValuesChange } = useBasicForm({
        onSubmit,
        setIsChangedFormValues,
    });

    const handleSubmit = (values) => {
        const formattedValues = {
            ...values,
            restaurantId: restaurantId,
        };
        console.log(values);

        return mixinFuncs.handleSubmit(formattedValues);
    };

    useEffect(() => {
        if (dataDetail) {
            // gọi API lần đầu
            form.setFieldsValue({
                ...dataDetail,
            });
        } else {
            form.setFieldsValue({
                code: 'MERGE_PORT',
            });
        }
    }, [dataDetail]);

    return (
        <BaseForm id={formId} onFinish={handleSubmit} form={form} onValuesChange={onValuesChange}>
            <Card className="card-form" bordered={false}>
                <Row gutter={16}>
                    <Col span={12}>
                        <SelectField
                            required
                            label={<FormattedMessage defaultMessage="Code" />}
                            name="code"
                            disabled={isEditing}
                            options={codeThirdParty}
                            onChange={(value) => {
                                if (value == 'MERGE_PORT')
                                    setHidden(false);
                                else
                                    setHidden(true);
                            }}
                        />
                    </Col>
                    {hidden && <Col span={12}>
                        <TextField
                            label={<FormattedMessage defaultMessage="User ID" />}
                            name="userId "
                        />
                    </Col>}
                    <Col span={24}>
                        <TextField
                            label={<FormattedMessage defaultMessage="Api key" />}
                            name="apiKey"
                            type="textarea"
                        />
                    </Col>
                </Row>
                <div className="footer-card-form">{actions}</div>
            </Card>
        </BaseForm>
    );
};

export default ThirdPartyForm;
